import * as React from "react";
import * as ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {Router} from "react-router";
import {Global, ThemeProvider} from "@emotion/react";
import {applyMiddleware, compose, createStore, Dispatch} from "redux";
import {promiseMiddleware} from "@web2/ap-request";
import {GhThemeProvider, themeGh} from "@web2/global_styles";

import {logOut} from "../login/actions/logout";
import {Layout} from "./components/Layout";
import {apReducers} from "./reducers/ap_reducer";
import {globalStylesGhMp} from "./styles/globalStylesGhMp";
import {addErrorStatusAlert} from "./utils/add_error_status_alert";
import {apHistory} from "./utils/history";

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
    }
}

// TODO: we should define a minimal theme interface specific for this app
export type IAPTheme = typeof themeGh;

// handle Emotion 11 Theme typings
import "@emotion/react";
declare module "@emotion/react" {
    export interface Theme extends IAPTheme {}
}

const composeEnhancers = (process.env.NODE_ENV === "development" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const finalCreateStore = composeEnhancers(
    applyMiddleware(
        promiseMiddleware({
            onError401Status: () => logOut(),
            onErrorStatus: (status: number) => async (dispatch: Dispatch) => dispatch(addErrorStatusAlert(status)),
            notifyError: (error, context) => {
                // TODO: bugsnag?
                // notifyBugsnag(error, context);
                return null;
            },
            logData: {url: window.location.href}
        })
    )
)(createStore);
const store = finalCreateStore(apReducers, {});

ReactDOM.render(
    <Router history={apHistory}>
        <Provider store={store}>
            <ThemeProvider theme={themeGh}>
                <GhThemeProvider>
                    <Global styles={globalStylesGhMp} />
                    <Layout />
                </GhThemeProvider>
            </ThemeProvider>
        </Provider>
    </Router>,
    document.getElementById("root")
);
